import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { installAuthRefresh } from './Components/auth/session';

// Keep the session topped up for as long as the app is open.
installAuthRefresh();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="848849160805-mc039q2hjmafr8jknmar81fj9hhh6shf.apps.googleusercontent.com">
    <ChakraProvider theme = {theme}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ChakraProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
